import { createValidator, length, maxLength, required } from 'util/validation'

import { AnexoArquivoFormModel } from '../model-anexoArquivos'

export const validateAnexoArquivo = createValidator<AnexoArquivoFormModel>({
  arquivoUuid: [required, length(36)],
  titulo: [required, maxLength(80)],
  categoria: [required],
  observacao: [maxLength(200)],
})
